(function () {
  function initFaqPage(root) {
    if (!root || root.dataset.hqFaqInitialized === 'true') return;
    root.dataset.hqFaqInitialized = 'true';

    var search = root.querySelector('[data-hq-faq-search]');
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-hq-faq-filter]'));
    var suggestions = Array.prototype.slice.call(root.querySelectorAll('[data-hq-faq-suggestion]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-hq-faq-group]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-hq-faq-item]'));
    var status = root.querySelector('[data-hq-faq-status]');
    var empty = root.querySelector('[data-hq-faq-empty]');

    var activeCategory = 'all';

    function normalize(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
    }

    function itemText(item) {
      return normalize(item.textContent);
    }

    function updateActiveFilter() {
      filters.forEach(function (button) {
        var active = button.dataset.hqFaqFilter === activeCategory;

        button.classList.toggle('is-active', active);

        button.setAttribute(
          'aria-pressed',
          active ? 'true' : 'false'
        );
      });
    }

    function render() {
      var query = normalize(search ? search.value : '');
      var visibleTotal = 0;

      groups.forEach(function (group) {
        var groupCategory = group.dataset.hqFaqGroup;

        var categoryAllowed =
          activeCategory === 'all' ||
          activeCategory === groupCategory;

        var groupItems = Array.prototype.slice.call(
          group.querySelectorAll('[data-hq-faq-item]')
        );

        var visibleInGroup = 0;

        groupItems.forEach(function (item) {
          var matchesQuery =
            !query ||
            itemText(item).indexOf(query) !== -1;

          var visible =
            categoryAllowed &&
            matchesQuery;

          item.hidden = !visible;

          if (!visible && item.open) {
            item.open = false;
          }

          if (visible) {
            visibleInGroup += 1;
            visibleTotal += 1;
          }
        });

        group.hidden =
          !categoryAllowed ||
          visibleInGroup === 0;
      });

      if (empty) {
        empty.hidden = visibleTotal !== 0;
      }

      if (status) {
        if (!query && activeCategory === 'all') {
          status.textContent = '';
        } else {
          var label =
            visibleTotal === 1
              ? 'question'
              : 'questions';

          status.textContent =
            'Showing ' +
            visibleTotal +
            ' ' +
            label +
            '.';
        }
      }

      updateActiveFilter();
    }

    /* =====================================================
       ACCORDION

       Only one question remains open inside each category.
       ===================================================== */

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;

        var group = item.closest(
          '[data-hq-faq-group]'
        );

        if (!group) return;

        Array.prototype.slice.call(
          group.querySelectorAll(
            '[data-hq-faq-item]'
          )
        ).forEach(function (other) {
          if (other !== item) {
            other.open = false;
          }
        });
      });
    });

    /* =====================================================
       CATEGORY FILTERS
       ===================================================== */

    filters.forEach(function (button) {
      button.setAttribute(
        'aria-pressed',
        button.classList.contains('is-active')
          ? 'true'
          : 'false'
      );

      button.addEventListener(
        'click',
        function () {
          activeCategory =
            button.dataset.hqFaqFilter ||
            'all';

          render();

          var groupsRoot =
            root.querySelector(
              '[data-hq-faq-groups]'
            );

          if (groupsRoot) {
            var top =
              groupsRoot
                .getBoundingClientRect()
                .top +
              window.scrollY -
              110;

            window.scrollTo({
              top: top,
              behavior: 'smooth'
            });
          }
        }
      );
    });

    /* =====================================================
       SEARCH
       ===================================================== */

    if (search) {
      search.addEventListener(
        'input',
        render
      );

      search.addEventListener(
        'search',
        render
      );
    }

    /* =====================================================
       POPULAR SEARCH SUGGESTIONS
       ===================================================== */

    suggestions.forEach(function (button) {
      button.addEventListener(
        'click',
        function () {
          if (!search) return;

          activeCategory = 'all';

          search.value =
            button.dataset
              .hqFaqSuggestion ||
            '';

          search.focus();

          render();
        }
      );
    });

    render();
  }

  /* =======================================================
     BOOT
     Supports both normal storefront loads and Shopify
     Theme Editor section reloads.
     ======================================================= */

  function boot(scope) {
    var roots = [];

    if (
      scope &&
      scope.matches &&
      scope.matches(
        '[data-hq-faq-page]'
      )
    ) {
      roots.push(scope);
    }

    if (
      scope &&
      scope.querySelectorAll
    ) {
      roots = roots.concat(
        Array.prototype.slice.call(
          scope.querySelectorAll(
            '[data-hq-faq-page]'
          )
        )
      );
    }

    roots.forEach(initFaqPage);
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        boot(document);
      }
    );
  } else {
    boot(document);
  }

  /* Shopify Theme Editor support */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      boot(event.target);
    }
  );
})();